// NOMO motion: scroll reveals with stagger, image unveils, count-ups, hero parallax and a header that settles on scroll.
// Built to fail open: content above the fold is never hidden, hidden states only apply once this script is running
// (html.nb-motion-ready), and a timer keeps checking so blocks never stay invisible in browsers that throttle scroll events.
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;
  const html = document.documentElement;

  const TEXT_TARGETS = [
    '.section-kicker', '.section-title', '.section-copy',
    '.home-feature__content > *', '.transform-grid > *:not(.transform-media)', '.fits-grid > *:not(.transform-media)',
    '.nomo-impact__grid > *', '.nomo-evidence > *', '.founder-story__inner > *',
    '.faq details', '.final-cta > *', '.final-cta .page-width > *',
    '.proof-strip__item', '.review-card', '.nomo-community__slide', '.nb-press__label'
  ].join(',');
  const IMAGE_TARGETS = ['.home-feature__visual', '.transform-media', '.founder-story__image'].join(',');

  const pending = new Set();
  const counters = new Set();
  const viewH = () => Math.max(window.innerHeight || 0, html.clientHeight || 0, 480);
  const revealAll = () => { pending.forEach(el => el.classList.add('is-in')); pending.clear(); };

  const register = root => {
    const texts = [...root.querySelectorAll(TEXT_TARGETS)];
    const images = [...root.querySelectorAll(IMAGE_TARGETS)];
    const all = new Set([...texts, ...images]);
    all.forEach(el => {
      if (el.dataset.nbMotion) return;
      el.dataset.nbMotion = '1';
      let parent = el.parentElement;
      while (parent) { if (all.has(parent)) return; parent = parent.parentElement; }
      if (el.closest('.campaign, .product-hero, dialog, [data-nb-unfold]')) return;
      if (el.getBoundingClientRect().top < viewH() * 0.92) return;
      const siblings = [...el.parentElement.children].filter(child => all.has(child));
      el.style.setProperty('--nb-i', Math.min(siblings.indexOf(el), 5));
      el.classList.add(images.includes(el) ? 'nb-unveil' : 'nb-rise');
      pending.add(el);
    });
    root.querySelectorAll('[data-nb-count]').forEach(el => {
      if (el.dataset.nbCounted) return;
      el.dataset.nbCounted = '1';
      counters.add(el);
    });
  };

  const countUp = el => {
    const end = Number(el.dataset.nbCount) || 0;
    const suffix = el.dataset.nbSuffix || '';
    const fmt = n => Math.round(n).toLocaleString('nl-NL') + suffix;
    const start = performance.now();
    const duration = 1400;
    const step = now => {
      const t = Math.min(1, (now - start) / duration);
      el.textContent = fmt(end * (1 - Math.pow(1 - t, 3)));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    setTimeout(() => { el.textContent = fmt(end); }, duration + 250);
  };

  const check = () => {
    const limit = viewH() * 0.9;
    pending.forEach(el => {
      const r = el.getBoundingClientRect();
      // In view, or already scrolled past (fast flicks / jumps to an anchor).
      if (r.top < limit) { el.classList.add('is-in'); pending.delete(el); }
    });
    counters.forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < limit && r.bottom > 0) { counters.delete(el); countUp(el); }
    });
  };

  const heroImg = document.querySelector('.campaign__media img');
  const header = document.querySelector('.site-header');
  const desktop = window.matchMedia('(min-width: 900px) and (hover: hover)');
  let ticking = false;
  const onFrame = () => {
    ticking = false;
    check();
    const y = window.scrollY || html.scrollTop || 0;
    if (heroImg && desktop.matches && y < viewH() * 1.2) heroImg.style.transform = `translate3d(0, ${y * 0.12}px, 0) scale(1.04)`;
    if (header) header.classList.toggle('is-scrolled', y > 8);
  };
  const queue = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(onFrame);
    setTimeout(() => { if (ticking) onFrame(); }, 120);
  };

  try {
    register(document);
    html.classList.add('nb-motion-ready');
    ['scroll', 'resize', 'touchmove', 'orientationchange'].forEach(type => window.addEventListener(type, queue, {passive: true}));
    window.addEventListener('pageshow', queue);
    window.addEventListener('load', queue);
    document.addEventListener('shopify:section:load', event => { register(event.target); queue(); });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) queue(); }, {rootMargin: '0px 0px -8% 0px'});
      pending.forEach(el => io.observe(el));
    }
    // Safety net for browsers that pause scroll events: keep checking until everything is shown.
    const poll = setInterval(() => { if (!pending.size && !counters.size) clearInterval(poll); else check(); }, 400);
    onFrame();
  } catch (error) {
    revealAll();
    html.classList.remove('nb-motion-ready');
  }
  if (reduce.addEventListener) reduce.addEventListener('change', () => { if (reduce.matches) revealAll(); });
})();
